var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"lazyimage",style:('width:'+_vm.width+'px;')},[_c('div',{staticClass:"fig-container",style:('padding-bottom:'+_vm.scale)},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fig-canvas"},[_c('img',{staticClass:"loader",attrs:{"src":"assets/images/loading.gif","alt":"loading","width":"32","height":"32"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1ccadd4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/vue/components/LazyImage.vue
// module id = 11
// module chunks = 0